import { Box, FormControlLabel, FormGroup, Radio, RadioProps, Typography } from '@mui/material';
import React from 'react';

interface IProps {
    label?: React.ReactNode;
    helperText?: string | React.ReactNode;
    children?: React.ReactNode;
}

export type MprcRadioProps = IProps & RadioProps;

export const MprcRadio: React.FC<MprcRadioProps> = ({ label, helperText, children, ...rest }) => {

    if (label == undefined)
        return <Radio {...rest} />;

    return (
        <FormGroup>
            <FormControlLabel
                control={<Radio size={rest.size ?? "small"} {...rest} />}
                label={label}
                disabled={rest.disabled}
            />
            {
                (helperText != undefined || children) &&
                <Box sx={{ ml: 3 }}>
                    <Typography variant="caption" component="p">{helperText}</Typography>
                    {children}
                </Box>
            }
        </FormGroup>
    );
};
